import { drugCategoryActions, drugsActions, drugUploadActions } from '../../../actions/medication/drugs/drugs';
import RestClient from '../../../../api/axiosInterceptor';

// Helper function to handle async actions
const createAsyncAction = (actionTypes, apiCall) => async (dispatch) => {
  dispatch({ type: actionTypes.REQUEST });

  try {
    const response = await apiCall();
    dispatch({ type: actionTypes.SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: actionTypes.FAILURE, error: error.message });
  }
};

// Fetch all drug categories with caching and optional search term
export const fetchDrugCategories = (searchTerm = '') => async (dispatch, getState) => {
  const cachedCategories = getState().drug_categories?.data || [];

  if (cachedCategories.length && !searchTerm) {
    dispatch({ type: drugCategoryActions.FETCH_CATEGORIES.SUCCESS, payload: cachedCategories });
    return cachedCategories; // Return cached categories
  }

  dispatch({ type: drugCategoryActions.FETCH_CATEGORIES.REQUEST });

  try {
    const { data } = await RestClient.get('/medication/drug_categories');
    dispatch({ type: drugCategoryActions.FETCH_CATEGORIES.SUCCESS, payload: data });
    return data; // Return fetched data
  } catch (error) {
    dispatch({ type: drugCategoryActions.FETCH_CATEGORIES.FAILURE, error: error.message });
    throw error; // Throw error to be caught in the component
  }
};

// Upload a drug (no caching needed for uploads)
export const uploadDrug = (formData) => createAsyncAction(drugUploadActions.UPLOAD_DRUG, () =>
  RestClient.post('/medication/drug/', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
);

// Fetch all drugs with caching
export const fetchAllDrugs = () => async (dispatch, getState) => {
  const cachedDrugs = getState().drugs?.data || [];

  if (cachedDrugs.length) {
    return dispatch({ type: drugsActions.FETCH_DRUGS.SUCCESS, payload: cachedDrugs });
  }

  dispatch({ type: drugsActions.FETCH_DRUGS.REQUEST });

  try {
    const { data } = await RestClient.get('/medication/drug/');
    dispatch({ type: drugsActions.FETCH_DRUGS.SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: drugsActions.FETCH_DRUGS.FAILURE, error: error.message });
  }
};

// Fetch a specific drug by its ID with caching
export const fetchDrugById = (public_id) => async (dispatch, getState) => {
  const cachedDrugs = getState().drugs?.data || [];
  const cachedDrug = cachedDrugs.find((drug) => drug.public_id === public_id);

  if (cachedDrug) {
    return dispatch({ type: drugsActions.FETCH_DRUG_BY_ID.SUCCESS, payload: cachedDrug });
  }

  dispatch({ type: drugsActions.FETCH_DRUG_BY_ID.REQUEST });

  try {
    const { data } = await RestClient.get(`/medication/drug/${public_id}`);
    dispatch({ type: drugsActions.FETCH_DRUG_BY_ID.SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: drugsActions.FETCH_DRUG_BY_ID.FAILURE, error: error.message });
  }
};
